<script setup lang="ts">
import { useI18n } from 'vue-i18n';
import { useChatStore, useChatStoreLanguage } from '../stores/chatStore';


const config = useRuntimeConfig();
const { messages } = useI18n()
const chatStore = useChatStore();
const ChatStoreLanguage = useChatStoreLanguage();

</script>
<template>
    <div>
        <VDropdown>
            <button type="button" class="flex" :aria-label="$t('selectLanguage')" v-tooltip="$t('selectLanguage')"
                style="display: block;">
                <Icon name="material-symbols:language" size="20px" /><span
                    class="block mt-[-9px] text-center text-[0.7em]">lang.</span>
            </button>

            <template #popper="{ hide }">
                <ul class="py-1 text-gray-70">
                    <li v-for="language in chatStore.languageMenus">
                        <a href="#" class="block py-2 px-4 hover:bg-gray-100 focus:bg-gray-100 outline-none"
                            @click="hide(); ChatStoreLanguage.clickLanguageMenu(language)">{{
                                messages[language.replace("-", "")]["name"]
                            }}</a>
                    </li>
                </ul>
            </template>
        </VDropdown>
    </div>
</template>